module.exports = __webpack_public_path__ + "static/img/23q1-dld2w.2b75836.jpg";